"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.MultipleSelectionHandles = void 0;
var _multipleSelectionHandles = require("./multipleSelectionHandles");
exports.PLUGIN_KEY = _multipleSelectionHandles.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _multipleSelectionHandles.PLUGIN_PRIORITY;
exports.MultipleSelectionHandles = _multipleSelectionHandles.MultipleSelectionHandles;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/multipleSelectionHandles/index.js
// module id = 1501
// module chunks = 0